const config = {
  "api_url_local": "http://0.0.0.0:8000", 
  "api_url_dev": "http://182.76.157.58:7076"
};

module.exports = config;